import Delete from '@mui/icons-material/Delete';
import { IconButton, IconButtonProps } from 'shared/mui/IconButtons';

export type DeleteIconButtonProps = Omit<IconButtonProps, 'icon'>;

export function DeleteIconButton(props: DeleteIconButtonProps): JSX.Element {
  return (
    <IconButton {...props}>
      <Delete fontSize="inherit" />
    </IconButton>
  );
}
